import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "vh-100 d-flex justify-content-center align-items-center"
}
const _hoisted_2 = {
  key: 1,
  class: "user-form email-setts"
}
const _hoisted_3 = { class: "user-form profile-form" }
const _hoisted_4 = { class: "row h2" }
const _hoisted_5 = { class: "col-md-6 col-sm-12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cart-check-fill" }, null, -1)
const _hoisted_7 = { class: "d-flex justify-content-end align-items-center col-md-6 col-sm-12" }
const _hoisted_8 = { class: "me-2" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "small-fs-1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-caret-left-fill" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clearboth" }, null, -1)
const _hoisted_15 = { class: "setting-data" }
const _hoisted_16 = { class: "row align-items-center" }
const _hoisted_17 = { class: "col-md-6 col-sm-12 mb-0" }
const _hoisted_18 = { class: "col-md-6 col-sm-12 d-flex justify-content-end" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "table" }
const _hoisted_22 = {
  "show-sm": "",
  "show-xs": "",
  "hide-md": "",
  "hide-lg": "",
  class: "d-block d-md-none"
}
const _hoisted_23 = { class: "d-block my-3" }
const _hoisted_24 = { class: "d-none d-md-block" }
const _hoisted_25 = { class: "d-none t-d-md-table-cell" }
const _hoisted_26 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_27 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { colspan: "4" }
const _hoisted_30 = { class: "text-center py-2" }
const _hoisted_31 = { class: "d-none d-md-block" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-eye-fill" }, null, -1)
const _hoisted_33 = {
  class: "d-block d-md-none",
  style: {"position":"relative"}
}
const _hoisted_34 = { style: {"padding":"5px 0"} }
const _hoisted_35 = { class: "bold" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-eye-fill" }, null, -1)
const _hoisted_37 = { style: {"padding":"5px 0"} }
const _hoisted_38 = { class: "bold" }
const _hoisted_39 = { style: {"padding":"5px 0"} }
const _hoisted_40 = { class: "bold" }
const _hoisted_41 = { style: {"padding":"5px 0"} }
const _hoisted_42 = { class: "bold" }
const _hoisted_43 = { class: "d-none t-d-md-table-cell" }
const _hoisted_44 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_45 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_46 = { class: "col-md-6 col-sm-12" }
const _hoisted_47 = { class: "area-info" }
const _hoisted_48 = { class: "col-md-6 col-sm-12" }
const _hoisted_49 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_jw_pager = _resolveComponent("jw-pager")!
  const _component_printer_dialog = _resolveComponent("printer-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isStillLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['fa', 'fa-spinner'],
            class: "fs-1"
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("form", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createTextVNode("  " + _toDisplayString(_ctx.language.delivery_details), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control input-sm",
                    placeholder: _ctx.language.search.toLowerCase(),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.itemSearchKey) = $event))
                  }, null, 8, _hoisted_9), [
                    [_vModelText, _ctx.itemSearchKey]
                  ])
                ])
              ])
            ]),
            _createElementVNode("p", _hoisted_10, [
              _createElementVNode("span", null, [
                _createVNode(_component_RouterLink, {
                  to: `/app/sales/deliveries/editor/${_ctx.getInfoRecord.orderKey}`
                }, {
                  default: _withCtx(() => [
                    _hoisted_11,
                    _createTextVNode("  " + _toDisplayString(_ctx.language.order_nbr) + ": ", 1),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.getInfoRecord.orderNbr), 1),
                    _hoisted_12,
                    _createTextVNode("       " + _toDisplayString(_ctx.language.deliv_nbr) + ": ", 1),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.getInfoRecord.deliveryNbr), 1),
                    _hoisted_13
                  ]),
                  _: 1
                }, 8, ["to"])
              ])
            ]),
            _createElementVNode("p", null, _toDisplayString(_ctx.language.delivery_details_msg), 1),
            _hoisted_14
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("h3", _hoisted_17, _toDisplayString(_ctx.language.delivery_details), 1),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-xs",
                    disabled: _ctx.lstSalesDeliveryDetails.length == 0,
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.printListItems && _ctx.printListItems(...args)))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'print'] }),
                    _createTextVNode(" " + _toDisplayString(_ctx.language.print), 1)
                  ], 8, _hoisted_19),
                  _createTextVNode("  "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-xs",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.refresListItems && _ctx.refresListItems(...args))),
                    disabled: _ctx.isStillLoading
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'refresh'] }),
                    _createTextVNode(" " + _toDisplayString(_ctx.language.refresh), 1)
                  ], 8, _hoisted_20)
                ])
              ])
            ])
          ]),
          _createElementVNode("table", _hoisted_21, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("span", _hoisted_22, [
                    _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.language.delivery_details), 1)
                  ]),
                  _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.language.product), 1)
                ]),
                _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.language.type), 1),
                _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.language.ordered_qty), 1),
                _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.language.deliv_qty), 1)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_ctx.lstSalesDeliveryDetails.length == 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_28, [
                    _createElementVNode("td", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.language.no_rec_fnd), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsPageElts, (salesDet) => {
                return (_openBlock(), _createElementBlock("tr", {
                  class: "acct-cal-verified",
                  key: salesDet.IdDeliveryDet
                }, [
                  _createElementVNode("td", null, [
                    _createElementVNode("span", _hoisted_31, [
                      _createTextVNode(_toDisplayString(_ctx.getProductRecord(salesDet)) + "  ", 1),
                      _createVNode(_component_RouterLink, {
                        title: _ctx.language.preview,
                        to: `/app/products/products/editor/${salesDet.ProductKey}`
                      }, {
                        default: _withCtx(() => [
                          _hoisted_32
                        ]),
                        _: 2
                      }, 1032, ["title", "to"])
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.language.product) + ":", 1),
                        _createTextVNode("  "),
                        _createElementVNode("span", null, [
                          _createTextVNode(_toDisplayString(_ctx.getProductRecord(salesDet)) + "  ", 1),
                          _createVNode(_component_RouterLink, {
                            title: _ctx.language.preview,
                            to: `/app/products/products/editor/${salesDet.ProductKey}`
                          }, {
                            default: _withCtx(() => [
                              _hoisted_36
                            ]),
                            _: 2
                          }, 1032, ["title", "to"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.language.type) + ":", 1),
                        _createTextVNode("  "),
                        _createElementVNode("span", null, _toDisplayString(salesDet.ProductOrient == 0 ? _ctx.language.product : _ctx.language.variant), 1)
                      ]),
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.language.ordered_qty) + ":", 1),
                        _createTextVNode("  "),
                        _createElementVNode("span", null, _toDisplayString(_ctx.appFxs.formatNumbers(salesDet.OrderedQty)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.language.deliv_qty) + ":", 1),
                        _createTextVNode("  "),
                        _createElementVNode("span", null, _toDisplayString(_ctx.appFxs.formatNumbers(salesDet.DeliveredQty)), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_43, _toDisplayString(salesDet.ProductOrient == 0 ? _ctx.language.product : _ctx.language.variant), 1),
                  _createElementVNode("td", _hoisted_44, _toDisplayString(_ctx.appFxs.formatNumbers(salesDet.OrderedQty)), 1),
                  _createElementVNode("td", _hoisted_45, _toDisplayString(_ctx.appFxs.formatNumbers(salesDet.DeliveredQty)), 1)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["row margin-to-15", {'d-none': _ctx.lstSalesDeliveryDetails.length==0}])
          }, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createTextVNode(_toDisplayString(_ctx.language.total_entries) + ": ", 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.lstSalesDeliveryDetails.length), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("nav", _hoisted_49, [
                _createVNode(_component_jw_pager, {
                  items: _ctx.filteredRecordItems,
                  initialPage: 1,
                  pageSize: _ctx.itemsPerPage,
                  maxPages: 10,
                  onChangePage: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onPageChange($event)))
                }, null, 8, ["items", "pageSize"])
              ])
            ])
          ], 2)
        ])),
    (_openBlock(), _createBlock(_Teleport, { to: "#modals-container" }, [
      _createVNode(_component_printer_dialog, {
        visible: _ctx.isPrintvisible,
        onCloseForm: _ctx.onPrintClose,
        printBaseData: _ctx.printInitialValues,
        extraPrintData: _ctx.printExtraData
      }, null, 8, ["visible", "onCloseForm", "printBaseData", "extraPrintData"])
    ]))
  ], 64))
}